import { useState } from "react";
import VendorForm from "./VendorForm";
import VendorList from "./VendorList";

const VendorSupplier = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <VendorForm addForm={setFromIsShown} update={upData}  sId={serviceId} />
      ) : (
        <VendorList addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
      )}
    </>
  );
};

export default VendorSupplier;
